import ajaxOptions from './plugins/ajax'
import permOptions from './plugins/perm'
import trackerOptions from './plugins/tracker'
import watermarkOptions from './plugins/watermark'

let siteOptions = {
	companyName: '美菜网',
	siteName: '美菜 · 大客户',
	indexPath: 'customerManagement/detail',
	theme: 'default',
	isShowDemoPages: false,	// 是否显示配置页面
	isTabbedMenu: false,	// 是否以页签的形式显示菜单。
	isShowDevTool: false,	// 是否显示右下角的开发者按钮。
	isShowMenuSearchBox: true,	// 是否显示菜单搜索框
	whenShowMenuSearchBox: 15,	// 超过多少个菜单时，才显示菜单搜索框，此处默认值为2，是为了测试。实际项目中一般设置为 > 10
	/**
	 * globalSiteLayout：
	 * 用于设置菜单布局。
	 * 未设置此项时，每一个页面可以单独设置布局（在 router.js 中）。
	 * 若设置了此项，则强制站点全部页面使用此布局（router.js 中的布局设置将失效）。
	 *
	 * 可选的布局配置有 3 种：
	 * HeaderLeftMainLayout：左侧菜单
	 * HeaderMainLayout：顶部菜单
	 * HeaderLeftMenusMainLayout：顶部+左侧菜单
	 */
	globalSiteLayout: 'HeaderLeftMainLayout',
	isLeftPaneCollapsable: false,
	/**
	 * 是否默认打开第一个子菜单页面，默认为 true (仅对于菜单同时存在于顶部与左侧时生效)。
	 * 若配置成 false，则需要注册父级菜单的路由。
	 *
	 * 如下所示的菜单配置：
	 * {
	 *	 "name": "表单示例",
	 *	 "icon": "el-icon-edit-outline",
	 *	 "path": "/demo/pages/form",
	 *	 "children": [{
	 *		 "name": "简单表单",
	 *		 "path": "/basic-form",
	 *		 "icon": "el-icon-menu"
	 *	 }]
	 * }
	 * 不仅需要注册子菜单路由：/demo/pages/form/basic-form
	 * 也需要注册父菜单路由：/demo/pages/form
	 */
	isOpenFirstChildMenu: true,
	copyrightText: 'Copyright © 2018 美菜网版权所有',
	departmentText: '大客户',
	...ajaxOptions,
	...permOptions,
	...trackerOptions,
	...watermarkOptions
}

export default siteOptions
